import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

interface DemandHeaderWrapperProps {
    isOpen: boolean;
    disabled: boolean;
}

export const DemandHeaderWrapper = styled.div<DemandHeaderWrapperProps>`
    background: ${(props) => (props.isOpen ? theme.colors.background.subtle : theme.colors.background.default)};
    border: 1px solid ${(props) => (props.isOpen ? theme.colors.border.muted : theme.colors.border.subtle)};
    padding: ${theme.space[8]} ${theme.space[16]};
    height: 48px;
    display: grid;
    justify-items: start;
    grid-template-columns: minmax(0, 20%) 10% 20% 30% 1fr;
    grid-column-gap: ${theme.space[8]};
    align-items: center;
    transition:
        background 75ms,
        border 75ms;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    user-select: none;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom-right-radius: ${(props) => (props.isOpen ? '0px' : '6px')};
    border-bottom-left-radius: ${(props) => (props.isOpen ? '0px' : '6px')};

    &:hover:not([disabled]) {
        background: ${theme.colors.background.subtle};
        border-color: ${theme.colors.border.muted};
    }
`;
